import type { FieldValues } from 'react-hook-form';

import RhfTextField, {
  type RhfTextFieldProps,
} from '../RhfTextField/RhfTextField';

type PresetProps = 'type' | 'inputMode' | 'autoComplete' | 'multiline';

export type RhfEmailFieldProps<T extends FieldValues> = Omit<
  RhfTextFieldProps<T>,
  PresetProps
>;

export default function RhfEmailField<T extends FieldValues>(
  props: RhfEmailFieldProps<T>
) {
  return (
    <RhfTextField<T>
      type='email'
      inputMode='email'
      autoComplete='email'
      {...props}
    />
  );
}
